import type { AmbianceAssetReferent } from '@matter_extractor/shared';

/**
 * The `data-testid` marks more than one file of this screen reads (issue
 * #121) - the régime `protocoles/contracts.ts` and `experiences/contracts.ts`
 * already follow: a mark two files agree on lives here once, rather than as a
 * string literal repeated in each.
 */

export const MEDIATHEQUE_GRID_TESTID = 'mediatheque-grille';
export const MEDIATHEQUE_EMPTY_TESTID = 'mediatheque-vide';
export const MEDIATHEQUE_CARD_TESTID = 'mediatheque-carte';
export const MEDIATHEQUE_UPLOAD_OPEN_TESTID = 'mediatheque-ajouter';
export const MEDIATHEQUE_UPLOAD_DIALOG_TESTID = 'mediatheque-boite-televerser';
export const MEDIATHEQUE_DELETE_TESTID = 'mediatheque-supprimer';
export const MEDIATHEQUE_DELETE_CONFIRM_TESTID = 'mediatheque-confirmation';
export const MEDIATHEQUE_IN_USE_TESTID = 'mediatheque-utilise';

/**
 * The referents of the ONE card a 409 `ASSET_IN_USE` last targeted - the
 * régime `protocoles/contracts.ts` and `experiences/contracts.ts` already
 * follow for a shape two files agree on: `mediatheque.tsx` (the route) and
 * `mediatheque-grid.tsx` (its prop type) each declared this structurally,
 * which is the same shape typed twice rather than named once.
 */
export type InUse = { assetId: string; referents: readonly AmbianceAssetReferent[] };
